import { useEffect } from 'react'

import { AuthStatus, useAuthContext } from '@space-shell/common/contexts/auth'
import { UserInfoRole } from '@space-shell/common/services/user'
import { useUserInfoStore, useViewAsStore } from '@space-shell/core/store'
import { DEFAULT_ROLE_TYPE, ViewAsFromPageType } from '@space-shell/core/store/types'
import { useSearchParams } from 'react-router-dom'

const SOURCE_PAGE = {
  HomePage: ViewAsFromPageType.Home,
  EditProductPage: ViewAsFromPageType.EditProduct,
  ListProductsPage: ViewAsFromPageType.ListProducts
}

const useInitializeViewAs = () => {
  const [searchParams] = useSearchParams()
  const { from } = useViewAsStore()
  const { role: userRole } = useUserInfoStore()
  const { authStatus } = useAuthContext()

  useEffect(() => {
    const isEnabled = userRole === UserInfoRole.OWNER
    const isAuthenticated = authStatus === AuthStatus.AUTHENTICATED

    if (!isEnabled || !isAuthenticated) {
      useViewAsStore.setState({ isEnabled: false })

      return
    }

    const fromParam = searchParams.get('from')
    const hasSourcePage = typeof fromParam === 'string' && Boolean(SOURCE_PAGE[fromParam])
    const sourcePage = hasSourcePage ? SOURCE_PAGE[fromParam] : from

    if (hasSourcePage) {
      useViewAsStore.setState({ role: DEFAULT_ROLE_TYPE })
    }

    useViewAsStore.setState({ isEnabled: true, from: sourcePage })
  }, [authStatus, from, searchParams, userRole])
}

export default useInitializeViewAs
